import { render, staticRenderFns } from "./HelpArticle.vue?vue&type=template&id=5a97a3d5&scoped=true&"
import script from "./HelpArticle.vue?vue&type=script&lang=js&"
export * from "./HelpArticle.vue?vue&type=script&lang=js&"
import style0 from "./HelpArticle.vue?vue&type=style&index=0&id=5a97a3d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97a3d5",
  null
  
)

export default component.exports